import React from "react";
import { withStyles } from "material-ui/styles";
import PropTypes from "prop-types";
import Avatar from "material-ui/Avatar";
import pink from "material-ui/colors/pink";
import avatarColor from "./helpers/avatarColor";

import { avatarInitials } from "./helpers/presentation";
const styles = theme => ({
  avatar: {
    flexShrink: 0,
    margin: 10,
    color: "#fff",
    backgroundColor: pink[900]
  }
});

const CurrentUser = props => {
  const { classes, currentUser } = props;
  const initials = avatarInitials(currentUser);
  const bgcolor = avatarColor(currentUser.email);
  return (
    <Avatar style={{ backgroundColor: bgcolor }} className={classes.avatar}>
      {initials}
    </Avatar>
  );
};

CurrentUser.propTypes = {
  currentUser: PropTypes.object.isRequired
};

export { CurrentUser };

export default withStyles(styles, { name: "CurrentUser" })(CurrentUser);



// WEBPACK FOOTER //
// ./src/CurrentUser.js